<template>
  <v-container fluid class="theme-color" style="height: 100%;">
    <UserManagement class="dialog mb-sm-5" :class="{ xs: $vuetify.breakpoint.xsOnly }" />
  </v-container>
</template>

<script>
import UserManagement from '../components/setting/UserManagement.vue';

export default {
  components: {
    UserManagement
  }
};
</script>

<style lang="scss" scoped></style>
